import { LoadingOverlay } from '@saas-ui/react'

export function DefaultLoader() {
  return (
    <LoadingOverlay.Root height="100dvh">
      <LoadingOverlay.Spinner />
    </LoadingOverlay.Root>
  )
}
